import React, { useEffect, useMemo, useState } from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";
import analyticsService from "../../redux/services/analytics.service";

const OrderStatusDistribution = ({ from, to, storeId }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      try {
        const res = await analyticsService.ordersByStatus({ from, to, storeId });
        const d = res.data?.data ?? res.data;
        if (!alive) return;
        setData(d ?? null);
      } catch {
        if (!alive) return;
        setData(null);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [from, to, storeId]);

  const labels = useMemo(() => {
    // Backend may return either { pending: 1, ... } or { rows:[{status,count}] }.
    if (!data) return [];
    if (Array.isArray(data.rows)) return data.rows.map((r) => r.status);
    return Object.keys(data);
  }, [data]);

  const series = useMemo(() => {
    if (!data) return [];
    if (Array.isArray(data.rows)) return data.rows.map((r) => Number(r.count ?? r.total ?? 0) || 0);
    return labels.map((k) => Number(data[k] ?? 0) || 0);
  }, [data, labels]);

  const options = useMemo(
    () => ({
      labels,
      legend: { position: "bottom" },
      title: { text: "Orders by status", align: "left" },
    }),
    [labels]
  );

  return (
    <Card className="mb-4 shadow-sm">
      <Card.Body>
        <div className="small text-muted mb-2">{loading ? "Loading…" : "Distribution"}</div>
        <Chart options={options} series={series} type="pie" height={300} />
      </Card.Body>
    </Card>
  );
};

export default OrderStatusDistribution;
